export default "__VITE_ASSET__g58dWOTz__"